module.exports = __webpack_public_path__ + "createstatic/media/Play.0f6b3d05.svg";